export default __webpack_public_path__ + "static/media/subaruNorthOrlando.92e41e50.png";